const getCookie = (name) => {
  const nameEQ = `${encodeURIComponent(name)}=`
  const cookies = document.cookie.split(';')

  const cookie = cookies.find((c) => {
    const trimmed = c.trim()
    return trimmed.startsWith(nameEQ)
  })

  if (cookie) {
    return decodeURIComponent(cookie.trim().substring(nameEQ.length))
  }
  return null
}

const setCookie = (name, value, days = 365, options = {}) => {
  const { secure = true, sameSite = 'Lax' } = options

  let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 864e5)
    cookieStr += `; expires=${date.toUTCString()}`
  }

  cookieStr += `; path=/; SameSite=${sameSite}`
  if (secure) cookieStr += `; Secure`

  document.cookie = cookieStr
}

export { getCookie, setCookie }
